export const CANCEL_ORDER = '取消订单';

export const URGE_ORDER = '催发货';

export const PAY = '继续支付';

export const APPLY_REFUND = '申请退款';

export const CHECKOUT_REFUND = '查看退款';

export const RETURN_GOODS_INFO = '填写退货信息';

export const CONFIRM_DELIVERY = '确认收货';

export const CHECKOUT_RETURN_GOODS = '查看退货';

export const CANCEL_RETURN_GOODS = '取消退货';

export const CHECKOUT_LOGISTICS = '查看物流';

export const CHECKOUT_COMMENT = '查看评价';

export const PUBLISH_COMMENT = '发表评价';

export const COMMENT_WITH_COUPON = '发表评价';

export const APPEND_COMMENT = '追加评价';

export const GO_TO_CLASS = '立即体验';

export const SHARE_ORDER = '晒单';

export const APPLY_ARBITRATE = '申请客服介入';

export const APPLY_AFTERSALE = '申请售后';

export const CANCEL_REFUND = '取消退款';

// 取消售前退款
export const CANCEL_ORDER_REFUND = '取消退款\u200b';

export const DELETE = '删除订单';

export enum ActionClass {
    Warn = 'warning',
    ExtraWide = 'extraWide',
    SECONDARY = 'secondary',
    PRIMARY = 'primary'
}

export enum ActionType {
    // button 是被收起状态
    FOLDING = 'folding'
}

export const EDIT_ADDRESS = '修改地址';

export const CHECK_VOUCHER = '查看券码';

export const CHECKOUT_CERTIFICATE = '鉴定结果';

export const FORBIDDEN_COMMENDERS = ['101531655586', '99514375927'];

// 订单详情页外部来源 - 特指订单中心跳如订单详情时传入的标记用于判断是否需要合并订单(不限制是否抖音, 全由 server 控制, server: 刘杰)
export const FROM_ORDER_LIST_STR = 'orderlist';

export const DOUYIN_ORDER_COLLECT =
    'aweme://webview/?url=https%3A%2F%2Faweme.snssdk.com%2Ffalcon%2Fe_commerce%2Frn%2Forder_collector_new%2F%3Fstatus_bar_color%3Dffffff%26status_font_dark%3D1%26hide_nav_bar%3D1%26loading_bgcolor%3Dffffff%26enter_from%3Dshopping_assistant%26origin_type%3D9902103010&status_bar_color=ffffff&status_font_dark=1&hide_nav_bar=1&loading_bgcolor=ffffff&enter_from=shopping_assistant&origin_type=9902103010&rn_schema=aweme%3A%2F%2Freactnative%2F%3Fmodule_name%3Dpage_order_collector_new%26status_bar_color%3Dffffff%26status_font_dark%3D1%26hide_nav_bar%3D1%26loading_bgcolor%3Dffffff%26channel%3Dfe_lyon_order_collector_new%26bundle%3Dindex.js%26enter_from%3Dshopping_assistant%26origin_type%3D9902103010';
